module.exports = __webpack_public_path__ + "img/new2.86a8b5f8.jpg";